export const summaryFileTemplateTypes = [
  'property_deal_billing_owner',
  'property_deal_billing_rentee',
  'deal_billing_owner',
  'deal_billing_rentee',
  'deal_settlement_owner',
  'deal_settlement_rentee',
  'deal_receipt'
] as const;
export type SummaryFileTemplateType = (typeof summaryFileTemplateTypes)[number];
export type SummaryFileTemplate = {
  id: number;
  templateType: SummaryFileTemplateType;
  fileName: string;
};
const SECTION = {
  property_deal: '案件グループ',
  deal: '案件'
} as const;

const ADDRESS = {
  owner: 'オーナー',
  rentee: '入居者',
  none: ''
} as const;

const TYPE = {
  billing: '請求書',
  settlement: '精算書',
  receipt: '発注書請書'
} as const;

export const summaryFileTemplateDetails = {
  property_deal_billing_owner: {
    section: SECTION.property_deal,
    address: ADDRESS.owner,
    type: TYPE.billing
  },
  property_deal_billing_rentee: {
    section: SECTION.property_deal,
    address: ADDRESS.rentee,
    type: TYPE.billing
  },
  deal_billing_owner: {
    section: SECTION.deal,
    address: ADDRESS.owner,
    type: TYPE.billing
  },
  deal_billing_rentee: {
    section: SECTION.deal,
    address: ADDRESS.rentee,
    type: TYPE.billing
  },
  deal_settlement_owner: {
    section: SECTION.deal,
    address: ADDRESS.owner,
    type: TYPE.settlement
  },
  deal_settlement_rentee: {
    section: SECTION.deal,
    address: ADDRESS.rentee,
    type: TYPE.settlement
  },
  deal_receipt: {
    section: SECTION.deal,
    address: ADDRESS.none,
    type: TYPE.receipt
  }
} as const satisfies {
  [key in SummaryFileTemplateType]: {
    section: string;
    address: string;
    type: string;
  };
};
